<template>
  <div class="issue" :key="forceReRender">
    <ul class="protocolList"
        v-for="(rowData, rowIndex) in groupedProtocolObj" :key="rowIndex">
      <ul class="protocolItem group">
        <!-- 카테고리 타입들을 표시 -->
        <ul class="type" data-grid="type"
            @mousedown.stop="startDrag"
            @mousemove.stop="onDrag"
            @mouseup.stop="endDrag"
            @mouseleave.stop="endDrag">
          <li
                  v-for="(category, categoryIndex) in rowData[0]"
                  :key="categoryIndex"
                  :data-type="category.type.toLowerCase()"
                  :data-items="category.items[0]"
          >
            {{ellipsisText(category.items[0])}}
          </li>
        </ul>

        <!-- 프로토콜 아이템 표시 -->
        <li class="protocolItem"
            :class="{'active': rowData[2].protocolId == selectedProtocolId || rowData[1].includes(keyOfProtocol)}"
        >
          <div class="info" data-grid="info">
            <p class="title" data-grid="title" v-html='rowData[2].name'></p>
            <p class="titleEng" data-grid="titleEng" v-html="rowData[2].nameEng"></p>
            <p class="user">
              <span>{{rowData[2].user.userName}}</span>
              <span>{{rowData[2].user.companyName}}</span>
            </p>
          </div>
          <div class="link" data-grid="link">
            <button @click="callProtocolDetail(rowData[2].protocolId, 'tree')">트리</button>
            <button @click="callProtocolDetail(rowData[2].protocolId, 'wiki')">위키</button>
          </div>
        </li>
      </ul>
    </ul>
  </div>
</template>

<script>
  import CommNew from "@processEditor/CommNew";
  import {createNamespacedHelpers} from "vuex";

  const ProcessEditor = createNamespacedHelpers('ProcessEditor');
  const Hub = createNamespacedHelpers('Hub');

  export default {
    mixins: [CommNew],
    props: {
      protocolList: {type: Array, default: []},
      connectedProtocolCount: {type: Number, default: 0},
    },
    data() {
      return {
        protocols: [],
        keyOfProtocol: null,
        groupedProtocolObj: {},
        selectedProtocolId: null,
        forceReRender: 0,
      }
    },
    watch: {
      async protocolList(value) {
        await this.setProtocols();
      },
      getSelectedNode: {
        deep: true,
        async handler(value) {
          if (value?.key) {
            this.keyOfProtocol = value.key;
          } else {
            this.keyOfProtocol = null;
          }
        }
      },
      getProtocolDetailObj: {
        deep: true,
        async handler(value) {
          if (value.protocolDetailPopFlag === true && typeof value.protocolDetailData == 'object') {
            this.selectedProtocolId = value.protocolDetailData.protocolId;
          } else if (value.protocolDetailPopFlag === false) {
            this.selectedProtocolId = null;
          }
        }
      },
    },
    computed: {
      ...ProcessEditor.mapGetters(['getDiagram', 'getSelectedNode']),
      ...Hub.mapGetters(
          [
            'getProtocolDetailObj'
          ]),
    },
    mounted() {
    },
    methods: {
      ...Hub.mapMutations([
        'setProtocolDetailObj'
      ]),
      setProtocols() {
        this.protocols = [];
        this.groupedProtocolObj = {};

        const protocolGroups = new Map();

        for (const protocolObj of this.protocolList) {
          const protocol = protocolObj.protocol;

          // user 속성이 있는 프로토콜만 처리
          if (!protocol.user) continue;

          this.protocols.push(protocol);

          const {protocolId} = protocol;

          // 그룹이 존재하지 않으면 초기화
          if (!protocolGroups.has(protocolId)) {
            protocolGroups.set(protocolId, {
              categories: [],
              innerKeys: [],
              protocol: protocol
            });
          }

          const group = protocolGroups.get(protocolId);

          // 카테고리와 내부 키 추가
          if (protocol.categorys?.[0]) {
            const categoryItem = protocol.categorys[0].items?.[0];
            const categoryType = protocol.categorys[0].type;
            const duplicateData = group.categories.filter(item => item.type == categoryType && item.items?.[0] == categoryItem)
            const isDuplicate = duplicateData.length > 0;
            if (!isDuplicate) {
              group.categories.push(protocol.categorys[0]);
            }
          }

          if (protocol.innerKeyOfProtocol) {
            group.innerKeys.push(protocol.innerKeyOfProtocol);
          }
        }

        // 그룹화된 데이터를 최종 객체에 할당
        for (const [protocolId, group] of protocolGroups) {
          this.groupedProtocolObj[protocolId] = [
            group.categories,
            group.innerKeys,
            group.protocol
          ];
        }
        this.$emit("update:connectedProtocolCount", protocolGroups.size)
        this.forceReRender++;
      },
      ellipsisText(value) {
        if (typeof value === 'string' || value instanceof String) {
          value = value.trimLeft().trimRight();
          const maxLength = 10;
          const addString = "...";
          return value.length > maxLength ? value.substring(0, maxLength) + addString : value;
        }
      },
      callProtocolDetail(protocolId, pageType) {
        this.keyOfProtocol = null;
        let protocolDetailData = {};
        protocolDetailData.protocolId = protocolId;
        protocolDetailData.processId = this.processId;
        protocolDetailData.isPublish = false;
        protocolDetailData.pageType = pageType;
        this.setProtocolDetailObj({
          openFlag: true,
          dataObj: protocolDetailData,
        });
      },
      // 드래그 스크롤 관련 메서드
      startDrag(e) {
        this.isDragging = true;
        this.startX = e.pageX - e.currentTarget.offsetLeft;
        this.scrollLeft = e.currentTarget.scrollLeft;
        e.currentTarget.style.cursor = 'grabbing';
      },

      onDrag(e) {
        if (!this.isDragging) return;
        e.preventDefault();
        const x = e.pageX - e.currentTarget.offsetLeft;
        const walk = (x - this.startX) * 2; // 스크롤 속도 조절 (2배)
        e.currentTarget.scrollLeft = this.scrollLeft - walk;
      },

      endDrag(e) {
        this.isDragging = false;
        e.currentTarget.style.cursor = 'grab';
      },
    },
  }
</script>
<style lang="scss" scoped>
  .issue {
    overflow: auto;
    overflow-x: hidden;
    @include scrlbar;
  }

  .overflow {
    height: calc(100% - 100px);
    @include scrlbar;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .protocolList {
    display: flex;
    flex-direction: column;
    gap: 8px;

    & + .protocolList {
      padding: 20px 0 0 0;
      border-top: 1px solid #ddd;
      margin: 20px 0 0 0;
    }

    .protocolItem {
      [data-grid="type"] {
        grid-area: type;
      }

      [data-grid="link"] {
        grid-area: link;
      }

      [data-grid="info"] {
        grid-area: info;
      }

      display: grid;
      gap: 8px;
      grid-template:
      'type' auto
      'info' auto
      'link' auto /
      1fr;
      // padding: 8px;
      padding: 8px 8px 0 8px;
      border: 1px solid #333;
      // border: 1px solid #ccc;
      border-radius: 5px;

      &.active {
        border: 2px solid #54BBC2;
        background-color: #E8F6F7;
      }

      &.group {
        padding-bottom: 10px;
      }

      .type {
        display: flex;
        gap: 4px;
        color: #000000;

        // 가로 스크롤 추가 (스크롤바 숨김)
        overflow-x: auto;
        overflow-y: visible;
        white-space: nowrap;
        padding-bottom: 40px; // 툴팁 공간 확보
        margin-bottom: -36px; // 툴팁 공간만큼 조정
        cursor: grab; // 드래그 커서

        // 드래그 중일 때 커서 변경
        &:active {
          cursor: grabbing;
        }

        // 스크롤바 완전히 숨기기
        &::-webkit-scrollbar {
          display: none;
        }

        // Firefox용 스크롤바 숨기기
        scrollbar-width: none;
        -ms-overflow-style: none;

        [data-type="material"] {
          order: 1;
          background: $color-material;
          border: 1px solid $color-border-material;

          &:after {
            color: #000000;
            background: $color-material;
            border: 1px solid $color-border-material;
          }
        }

        [data-type="process"] {
          order: 1;
          background: $color-process;
          border: 1px solid $color-border-process;

          &:after {
            color: #000000;
            background: $color-process;
            border: 1px solid $color-border-process;
          }
        }

        [data-type="equipment"] {
          order: 1;
          background: $color-analysis;
          border: 1px solid $color-border-analysis;

          &:after {
            color: #000000;
            background: $color-analysis;
            border: 1px solid $color-border-analysis;
          }
        }

        li {
          position: relative;
          padding: 4px 8px;
          border-radius: 7px;
          cursor: pointer;
          flex-shrink: 0; // 아이템이 줄어들지 않도록 고정

          &:after {
            visibility: hidden;
            content: attr(data-items);
            display: block;
            position: absolute;
            top: 103%;
            left: 0;
            max-width: 220px;
            padding: 8px;
            border-radius: 3px;
            color: #fff;
            font-size: 12px;
            white-space: nowrap;
            z-index: 9999; // 높은 z-index 유지
          }

          &:hover {
            &::after {
              visibility: visible;
            }
          }

          &:nth-child(1) {
          }
        }
      }

      p {
        width: 100%;
        overflow: hidden;
      }

      .info {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }

      .link {
        display: flex;
        justify-content: flex-end;
        gap: 4px;

        button {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 2px;
          width: 100%;
          min-height: 30px;
          padding: 4px 8px;
          // border: 1px solid #333;
          border-top: 1px solid #ccc;
          // border-radius: 2px;
          &:before {
            content: '';
            display: inline-block;
            width: 14px;
            height: 14px;
            background: url('../../../assets/icons/icon-eye.svg') center no-repeat;
          }

          &:hover {
            border-top-color: #333;
          }
        }
      }

      .user {
        display: flex;
        gap: 8px;
        color: #ccc;
        font-size: 12px;

        span {
          display: block;

          & + span {
            padding-left: 8px;
            border-left: 1px solid #eee;
          }
        }
      }
    }
  }
</style>